// @ts-check
import { initSchema } from '@aws-amplify/datastore'
import { schema } from './schema'

const AccountProvider = {
    COINBASE: 'COINBASE',
    VEZGO: 'VEZGO',
    PLAID: 'PLAID',
}

const ClientPlatform = {
    WEB: 'WEB',
    ANDROID: 'ANDROID',
    IOS: 'IOS',
}

const MasaConnectionProvider = {
    PLAID: 'PLAID',
    CRYPTO: 'CRYPTO',
    VEZGO: 'VEZGO',
    MASA: 'MASA',
}

const MasaAccountType = {
    BANK: 'BANK',
    CRYPTO: 'CRYPTO',
}

const CryptoDataProviders = {
    MASA: 'MASA',
    VEZGO: 'VEZGO',
}

const DeleteType = {
    TOTAL: 'TOTAL',
    HARD: 'HARD',
    SOFT: 'SOFT',
}

const UserRole = {
    INDIVIDUAL: 'INDIVIDUAL',
    BUSINESS: 'BUSINESS',
    LIQUIDITY_PROVIDER: 'LIQUIDITY_PROVIDER',
    VALIDATOR: 'VALIDATOR',
    ADMIN: 'ADMIN',
}

const CryptoAccountProvider = {
    VEZGO: 'VEZGO',
    MASA: 'MASA',
}

const {
    PlaidAccount,
    UserProfile,
    Country,
    LoanApplication,
    UserProductInterest,
    ProductInterest,
    FeatureFlag,
    CreditScoreProvider,
    UserCreditScore,
    SystemCredentials,
    PlaidUserInfo,
    PlaidReportToken,
    PlaidHistoricalBalance,
    PlaidAccountIdentity,
    PlaidAccountTransaction,
    ZaboUserInfo,
    CryptoUserConnection,
    ZaboAccountBalance,
    ZaboHistoricalBalance,
    ZaboAccountTransaction,
    listLoanApplicationsFromNodeResponse,
    LoanApplicationFromNode,
    LoanApplicationFromNodeData,
    LoanApplicationFromNodeCollateralData,
    LoanApplicationFromNodeCollateralMetadata,
    LoanApplicationFromNodeRepayment,
    getLoanApplicationsFromNodeResponse,
    GetPreQualificationDataResponseType,
    GetLinkResponseType,
    VezgoProvider,
    GetApprovedCountriesResponseType,
    ListMasaAccountsResponse,
    MasaAccount,
    MasaAmount,
    ListBankTransactionsResponse,
    BankTransaction,
    TransactionComplexField,
    ListCryptoTransactionsResponse,
    CryptoTransaction,
    GetGraphDataResponse,
    GraphDataPoint,
    RegisterCreditScoreRepresentativeResponse,
    ProcessedBloomCreditQuestions,
    ProcessedBloomCreditQuestionsOption,
    AuthenticateCreditScoreRepresentativeResponse,
    FetchCreditScoreResponse,
    ExchangePublicTokenResponseType,
    UpdateUserInterestsResponseType,
    RegenerateUserDataOutput,
    PlaidIdentityAddress,
    ZaboProvider,
    ZaboTransactionPart,
    ZaboTransactionFee,
    listLoansFromNodeResponse,
    ClientMetadata,
} = initSchema(schema)

export {
    PlaidAccount,
    UserProfile,
    Country,
    LoanApplication,
    UserProductInterest,
    ProductInterest,
    FeatureFlag,
    CreditScoreProvider,
    UserCreditScore,
    SystemCredentials,
    PlaidUserInfo,
    PlaidReportToken,
    PlaidHistoricalBalance,
    PlaidAccountIdentity,
    PlaidAccountTransaction,
    ZaboUserInfo,
    CryptoUserConnection,
    ZaboAccountBalance,
    ZaboHistoricalBalance,
    ZaboAccountTransaction,
    AccountProvider,
    ClientPlatform,
    MasaConnectionProvider,
    MasaAccountType,
    CryptoDataProviders,
    DeleteType,
    UserRole,
    CryptoAccountProvider,
    listLoanApplicationsFromNodeResponse,
    LoanApplicationFromNode,
    LoanApplicationFromNodeData,
    LoanApplicationFromNodeCollateralData,
    LoanApplicationFromNodeCollateralMetadata,
    LoanApplicationFromNodeRepayment,
    getLoanApplicationsFromNodeResponse,
    GetPreQualificationDataResponseType,
    GetLinkResponseType,
    VezgoProvider,
    GetApprovedCountriesResponseType,
    ListMasaAccountsResponse,
    MasaAccount,
    MasaAmount,
    ListBankTransactionsResponse,
    BankTransaction,
    TransactionComplexField,
    ListCryptoTransactionsResponse,
    CryptoTransaction,
    GetGraphDataResponse,
    GraphDataPoint,
    RegisterCreditScoreRepresentativeResponse,
    ProcessedBloomCreditQuestions,
    ProcessedBloomCreditQuestionsOption,
    AuthenticateCreditScoreRepresentativeResponse,
    FetchCreditScoreResponse,
    ExchangePublicTokenResponseType,
    UpdateUserInterestsResponseType,
    RegenerateUserDataOutput,
    PlaidIdentityAddress,
    ZaboProvider,
    ZaboTransactionPart,
    ZaboTransactionFee,
    listLoansFromNodeResponse,
    ClientMetadata,
}
